import * as React from 'react';
import {transparentize} from 'polished';
import styled from 'styled-components';
import {BlockLabel as Label, BlockTitle} from '../components/styled';
import {CoursePromoContext} from '../context';
import {TargetAudienceItem} from '../types';

const Container = styled.div`
  padding: 70px 60px 80px 60px;
  border-radius: 10px;
  background-color: ${({theme}) => theme.variables.accentBackgroundColor};
  
  @media screen and (max-width: 640px) {
    padding: 40px 16px 40px;
  }
`;

const Title = styled(BlockTitle)`
  margin-bottom: 40px;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 129px;
  grid-row-gap: 64px;

  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
    grid-row-gap: 30px;
  }
`;

const Item = styled.div`
  max-width: 466px;
`;

const IconBox = styled.div`
  display: flex;
  align-items: flex-end;
  height: 60px;
  width: 60px;
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ItemTitle = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: 600;
  line-height: 29px;
`;

const ItemDescription = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${({theme}) => `
    ${transparentize(.2, theme.colors.white)};
  `};
`;

/**
 * The returns course target audience component
 * @return {React.ReactElement}
 * @constructor
 */
export default function TargetAudience(): React.ReactElement {
  const context = React.useContext(CoursePromoContext);

  /**
   * Render course target audience items
   * @return {React.ReactNodeArray}
   * @constructor
   */
  function renderContent(): React.ReactNodeArray {
    return context
        .targetAudience
        .items
        .map(renderItems);
  }

  /**
   * Render course target audience item
   * @param {TargetAudienceItem} item
   * @param {number} ind
   * @constructor
   */
  function renderItems(item: TargetAudienceItem, ind: number) {
    const {title, description, preview} = item;
    return (
      <Item key={ind + item.toString()}>
        <IconBox>
          {preview && (
            <Icon src={preview} alt="icon"/>
          )}
        </IconBox>
        <ItemTitle>
          {title}
        </ItemTitle>
        <ItemDescription>
          {description}
        </ItemDescription>
      </Item>
    );
  }

  return (
    <Container>
      <Label>Для кого</Label>
      <Title>
        {context.targetAudience.title}
      </Title>
      <Content>
        {renderContent()}
      </Content>
    </Container>
  );
}
